import { _baseClient } from '../index';
import { setAuthToken } from '../../stores/auth';

export const checkAuth = async () => {
  const token = localStorage.getItem('token');
  const userInfo = localStorage.getItem('userInfo');
  if (token) {
    // enload persisted token into auth store
    setAuthToken(token, userInfo);
    return token;
  }
  throw Error('unauthorized');
};

export const login = async ({ email, password, otpCode }) => {
  if (!email || !password || !otpCode) {
    return Error('invalid email or password in apiClient.login');
  }

  return _baseClient
    .post('/login', {
      body: { email, password, otpCode },
    })
    .then((response) => {
      setAuthToken(response.data.authToken.accessToken, JSON.stringify(response.data));
      return response;
    });
};

export const validateLogin = async ({ email, password }) => {
  if (!email || !password) {
    return Error('invalid email or password in apiClient.validateLogin');
  }

  return _baseClient
    .post('/validate-login', {
      body: { email, password },
    })
    .then((response) => {
      return response;
    });
};

export const resendOtp = async ({ email }) => {
  if (!email) {
    return Error('invalid email or password in apiClient.resendOtp');
  }

  return _baseClient
    .post('/resend-otp', {
      body: { email },
    })
    .then((response) => {
      return response;
    });
};

export const validateSetupCode = async ({ code }) => {
  if (!code) {
    return Error('invalid code in apiClient.validateSetupCode');
  }

  return _baseClient
    .post('/validate-setup-code', {
      body: { code },
    })
    .then((response) => {
      return response;
    });
};

export const forgotPassword = async ({ email }) => {
  if (!email) {
    return Error('invalid email in apiClient.forgotPassword');
  }

  return _baseClient
    .post('/forgot-password', {
      body: { email },
    })
    .then((response) => {
      return response;
    });
};

export const setupPassword = async ({ code, password }) => {
  if (!code || !password) {
    return Error('invalid email in apiClient.setupPassword');
  }

  return _baseClient
    .post('/setup-password', {
      body: { code, password },
    })
    .then((response) => {
      return response;
    });
};

export const resetPassword = async ({ code, password }) => {
  if (!code || !password) {
    return Error('invalid email in apiClient.resetPassword');
  }
  return _baseClient
    .post('/reset-password', {
      body: { code, password },
    })
    .then((response) => {
      return response;
    });
};

export const userInfo = async () => {
  return _baseClient.get('/user/get-info');
};
